import { DetailsPanelActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getEnquiryDetailsStart = (payload: any) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_START, payload);
export const getEnquiryDetailsSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_SUCCESS, payload);
export const getEnquiryDetailsFailure = (error: string) =>
  action(DetailsPanelActionTypes.GET_ENQUIRY_DETAILS_FAILURE, error);

export const downloadCombinedPDFStart = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_START, payload);
export const downloadCombinedPDFSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_SUCCESS, payload);
export const downloadCombinedPDFFailure = (error: string) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_PDF_FAILURE, error);

export const downloadCombinedZIPStart = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_START, payload);
export const downloadCombinedZIPSuccess = (payload: any) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_SUCCESS, payload);
export const downloadCombinedZIPFailure = (error: string) =>
  action(DetailsPanelActionTypes.DOWNLOAD_COMBINED_ZIP_FAILURE, error);
